import PocketBase from "pocketbase";

// One same-origin PocketBase instance for the whole app. The UI is served by the
// same binary, so the base URL is the current origin — no base URL is baked into
// the bundle and no token is embedded (N5). The SDK's default LocalAuthStore
// persists the session token in localStorage and re-attaches it to auto-REST
// requests automatically.
export const pb = new PocketBase(window.location.origin);

/** authStore is re-exported for convenience (auth guards, account UI). */
export const authStore = pb.authStore;

/**
 * authHeader returns the Bearer Authorization header for the custom
 * /api/registry/* routes, which (unlike auto-REST) need the token passed
 * explicitly. Returns an empty object when there is no valid session.
 */
export function authHeader(): Record<string, string> {
  return pb.authStore.isValid
    ? { Authorization: "Bearer " + pb.authStore.token }
    : {};
}
